import { render, staticRenderFns } from "./IndoorAir.vue?vue&type=template&id=4efb9992&"
import script from "./IndoorAir.vue?vue&type=script&lang=js&"
export * from "./IndoorAir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports